export default "__VITE_ASSET__CKNP5x7w__"